import React from 'react'
import "./../../A2Page/A2Page.css";
import C1WhyHead from './C1WhyHead';
import C1WhyMain from './C1WhyMain';

const C1Why = () => {
  return (
    <div className='a2WhyContainer'>
      <C1WhyHead/>
      <C1WhyMain/>
    </div>
  )
}

export default C1Why
